/* global $ */

const bee_scorecard_elements = [
  {
    title: "Ownership",
    description: "Black ownership, voting rights, and economic interest",
    points: "27 pts",
    icon: "👥",
    accent_class: "bg-success",
  },
  {
    title: "Management Control",
    description: "Board and executive representation, employment equity",
    points: "23 pts",
    icon: "👔",
    accent_class: "bg-primary",
  },
  {
    title: "Skills Development",
    description: "Training spend, learnerships, bursaries, and accredited programmes",
    points: "25 pts",
    icon: "📚",
    accent_class: "bg-purple",
  },
  {
    title: "Enterprise & Supplier Development",
    description: "Preferential procurement, supplier and enterprise development",
    points: "44 pts",
    icon: "🤝",
    accent_class: "bg-warning",
  },
  {
    title: "Socio-Economic Development",
    description: "Community contributions, volunteer initiatives, and CSI",
    points: "5 pts",
    icon: "❤️",
    accent_class: "bg-danger",
  },
  {
    title: "YES Programme",
    description: "Youth Employment Service initiative for bonus points",
    points: "Bonus",
    icon: "🎯",
    accent_class: "bg-success",
  },
];

/* ===============================
   RENDER SCORECARD ELEMENTS
   =============================== */

$(document).ready(function () {
  const $grid = $("#bee_scorecard_grid");
  const template = document.getElementById("bee_scorecard_template");

  // Silently return if template or grid doesn't exist (not on landing page)
  if (!template || !$grid.length) {
    return;
  }

  $.each(bee_scorecard_elements, function (_, element) {
    const node = template.content.cloneNode(true);
    const $node = $(node);

    $node.find(".scorecard_title").text(element.title);
    $node.find(".scorecard_description").text(element.description);
    $node.find(".scorecard_points").text(element.points);
    $node.find(".scorecard_icon").text(element.icon);

    $node.find(".scorecard_accent")
      .addClass(element.accent_class);

    $grid.append($node);
  });
});
